import { generateId } from '@freelancer/datastore/testing/helpers';
import type { UserAvailabilityAgent } from './user-availability-agent.model';

export interface GenerateUserAvailabilityAgentOptions {
  /** The id of the user availability this agent enquiry relates to. */
  readonly id?: number;
  readonly agentUserId?: number;
}

export function generateUserAvailabilityAgentObject({
  id = generateId(),
  agentUserId,
}: GenerateUserAvailabilityAgentOptions = {}): UserAvailabilityAgent {
  return {
    id,
    agentUserId,
  };
}
